/**
 * The refusal outcomes `POST /enrolment` publishes, mirrored from the api's own DTO.
 *
 * Source: `iss-kiosk-api` @ `develop` `src/modules/enrolment/dto/enrolment.model.ts` — `ENROLMENT_REFUSAL`,
 * shipped by 03-us-kad-6b. ⚠️ **Hand-written, and the convention (§ 6) says types are generated** from the
 * api's OpenAPI schema via `npm run api:types`. That script reads `../iss-kiosk-api/openapi.json`, which the
 * backend does not emit yet — the same gap `identityLookup.ts` and `arrivalReason.ts` both record. The three
 * values below are the api's, byte for byte.
 *
 * It is a module of its own so the screens can name an outcome without importing the egress.
 */
export const ENROLMENT_REFUSAL = {
  /** The PIN opened no venue. ⛔ Byte-identical whether it belongs to another venue or to nowhere [0090]. */
  incorrectPin: 'incorrect_pin',
  /** Layer 1: three failures on this browser's token. ⛔ Only an admin clears it [0052; 0203]. */
  deviceLocked: 'device_locked',
  /** Layer 2: too many failed attempts from this address. ⛔ Temporary, and it clears itself [0203]. */
  throttled: 'throttled',
} as const;

export type EnrolmentRefusalOutcome = (typeof ENROLMENT_REFUSAL)[keyof typeof ENROLMENT_REFUSAL];
